(() => {
    const header = document.querySelector('[data-custom-header]');
    if (!header || header.dataset.initialised === 'true') return;
    header.dataset.initialised = 'true';

    const trigger = header.querySelector('[data-explore-trigger]');
    const triggers = [...document.querySelectorAll('[data-explore-trigger]')];
    const dialog = header.querySelector('[data-explore-dialog]');
    const panel = dialog?.querySelector('[data-explore-panel]');
    const handle = dialog?.querySelector('[data-explore-handle]');
    const body = dialog?.querySelector('[data-explore-body]');
    const search = dialog?.querySelector('[data-explore-search]');
    const searchBox = dialog?.querySelector('[data-explore-search-box]');
    const suggest = dialog?.querySelector('[data-explore-suggest]');
    const links = dialog ? [...dialog.querySelectorAll('[data-explore-link]')] : [];
    const product = dialog?.querySelector('[data-explore-product]');
    const subscribe = dialog?.querySelector('[data-explore-subscribe]');
    const subscribeTrigger = subscribe?.querySelector('[data-explore-subscribe-trigger]');
    const subscribeForm = subscribe?.querySelector('form');
    const subscribeField = subscribe?.querySelector('.custom-explore__subscribe-field');
    const subscribeInput = subscribe?.querySelector('[data-explore-subscribe-input]');
    const subscribeStatus = subscribe?.querySelector('[data-explore-subscribe-status]');
    const subscribeStatusText = subscribe?.querySelector('[data-explore-subscribe-status-text]');
    const subscribeTags = subscribe?.querySelector('[data-explore-subscribe-tags]');
    const subscribeLists = subscribe ? [...subscribe.querySelectorAll('[data-explore-subscribe-list]')] : [];
    const subscribeSubmit = subscribeForm?.querySelector('button[type="submit"]');
    const hero = document.querySelector('#MainContent [class*="__hero"]') || document.querySelector('#MainContent .shopify-section');
    const isHome = document.body.classList.contains('template-index')
      || document.body.classList.contains('template-product');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobileSheet = window.matchMedia('(max-width: 640px)');
    let frame;
    let closing;
    let afterClose = null;
    let drag = null;
    let lastTrigger = null;

    const stickyBar = document.querySelector('[data-element-sticky-bar]');
    const footer = document.querySelector('.custom-footer');

    if (stickyBar && stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }

    if (dialog && dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    const mobileHeadings = [...document.querySelectorAll('#MainContent h1, #MainContent h2, #MainContent h3')];

    const updateTrigger = () => {
      const pastHero = !hero || hero.getBoundingClientRect().bottom <= 80;
      const footerBounds = footer?.getBoundingClientRect();
      const footerVisible = Boolean(
        footerBounds && footerBounds.top < window.innerHeight && footerBounds.bottom > 0
      );
      const exploreHidden = Boolean(dialog?.hidden);

      // Keep the floating mobile control clear of headings as they scroll past.
      const triggerBounds = trigger?.getBoundingClientRect();
      const coversHeading = mobileSheet.matches && triggerBounds && mobileHeadings.some((heading) => {
        const bounds = heading.getBoundingClientRect();
        return bounds.width > 0 && bounds.height > 0
          && bounds.top < triggerBounds.bottom + 12 && bounds.bottom > triggerBounds.top - 12
          && bounds.left < triggerBounds.right + 12 && bounds.right > triggerBounds.left - 12;
      });
      const triggerFocused = trigger === document.activeElement;
      trigger?.classList.toggle('is-visible', exploreHidden && !footerVisible && (!isHome || pastHero)
        && (!coversHeading || triggerFocused));
      footer?.classList.toggle('is-explore-active', footerVisible && exploreHidden);
      stickyBar?.classList.toggle('is-visible', pastHero);
      stickyBar?.classList.toggle('is-footer-visible', footerVisible);
    };

    const escapeHtml = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

    const highlightMatch = (value, query) => {
      const text = String(value || '');
      const index = text.toLowerCase().indexOf(query);
      if (index < 0) return escapeHtml(text);

      return `${escapeHtml(text.slice(0, index))}<b>${escapeHtml(text.slice(index, index + query.length))}</b>${escapeHtml(text.slice(index + query.length))}`;
    };

    const suggestCatalog = [
      ...links.map((link) => ({
        title: link.querySelector('span')?.textContent.trim() || link.textContent.trim(),
        subtitle: link.querySelector('small')?.textContent.trim() || '',
        href: link.getAttribute('href') || '',
        type: 'link'
      })),
      product
        ? {
            title: product.querySelector('strong')?.textContent.trim() || product.textContent.trim(),
            subtitle: 'Featured product',
            href: product.getAttribute('href') || '',
            type: 'product'
          }
        : null,
      subscribe
        ? {
            title: subscribeTrigger?.querySelector('span')?.textContent.trim() || 'Newsletter',
            subtitle: subscribeTrigger?.querySelector('small')?.textContent.trim() || '',
            href: '',
            type: 'subscribe'
          }
        : null
    ].filter(Boolean);

    let activeSuggest = -1;
    let currentMatches = [];

    const hideSuggest = () => {
      activeSuggest = -1;
      currentMatches = [];
      if (suggest) {
        suggest.hidden = true;
        suggest.innerHTML = '';
      }
      searchBox?.classList.remove('is-suggesting');
      search?.setAttribute('aria-expanded', 'false');
      search?.removeAttribute('aria-activedescendant');
    };

    const setActiveSuggest = (index) => {
      if (!suggest) return;
      const items = [...suggest.querySelectorAll('[data-suggest-index]')];
      activeSuggest = items.length ? ((index % items.length) + items.length) % items.length : -1;
      items.forEach((item, itemIndex) => {
        const selected = itemIndex === activeSuggest;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
        if (selected) search?.setAttribute('aria-activedescendant', item.id);
      });
    };

    const openSuggestItem = (item) => {
      if (!item) return;

      if (item.type === 'subscribe') {
        hideSuggest();
        if (search) search.value = '';
        if (!subscribe?.classList.contains('is-open')) expandSubscribe();
        subscribe?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (item.href) {
        close(() => {
          window.location.assign(item.href);
        });
      }
    };

    const updateSearch = () => {
      const query = (search?.value || '').trim().toLowerCase();

      if (!query || !suggest) {
        hideSuggest();
        return;
      }

      const matches = suggestCatalog
        .map((item) => {
          const haystack = `${item.title} ${item.subtitle}`.toLowerCase();
          if (!haystack.includes(query)) return null;
          let score = 1;
          if (item.title.toLowerCase().startsWith(query)) score = 3;
          else if (item.title.toLowerCase().includes(query)) score = 2;
          return { item, score };
        })
        .filter(Boolean)
        .sort((left, right) => right.score - left.score)
        .slice(0, 6);

      if (!matches.length) {
        currentMatches = [];
        suggest.innerHTML = '<li class="custom-explore__suggest-empty">No matching pages</li>';
        suggest.hidden = false;
        searchBox?.classList.add('is-suggesting');
        search?.setAttribute('aria-expanded', 'true');
        activeSuggest = -1;
        return;
      }

      currentMatches = matches;
      suggest.innerHTML = matches.map(({ item }, index) => {
        const id = `ExploreSuggestOption-${index}`;
        const copy = `<span>${highlightMatch(item.title, query)}</span>${item.subtitle ? `<small>${escapeHtml(item.subtitle)}</small>` : ''}`;
        const control = item.type === 'subscribe'
          ? `<button type="button" id="${id}" data-suggest-index="${index}" role="option" aria-selected="false">${copy}</button>`
          : `<a href="${escapeHtml(item.href)}" id="${id}" data-suggest-index="${index}" role="option" aria-selected="false">${copy}</a>`;

        return `<li class="custom-explore__suggest-item">${control}</li>`;
      }).join('');

      suggest.hidden = false;
      searchBox?.classList.add('is-suggesting');
      search?.setAttribute('aria-expanded', 'true');
      setActiveSuggest(0);

      suggest.querySelectorAll('[data-suggest-index]').forEach((control) => {
        const match = matches[Number(control.dataset.suggestIndex)];
        control.addEventListener('mousedown', (event) => event.preventDefault());
        control.addEventListener('click', (event) => {
          event.preventDefault();
          openSuggestItem(match?.item);
        });
      });
    };

    const selectedSubscribeTags = () => subscribeLists
      .filter((input) => input.checked)
      .map((input) => input.value);

    const syncSubscribeTags = () => {
      if (!subscribeTags) return;
      const tags = ['newsletter', ...selectedSubscribeTags()];
      subscribeTags.value = [...new Set(tags)].join(', ');
    };

    const expandSubscribe = () => {
      const opening = !subscribe?.classList.contains('is-open');
      subscribe?.classList.toggle('is-open', opening);
      subscribeTrigger?.setAttribute('aria-expanded', String(opening));
      if (opening && !subscribe?.classList.contains('is-success')) {
        subscribeInput?.focus({ preventScroll: true });
      }
    };

    const hideSubscribeMessage = () => {
      subscribeStatus?.classList.remove('is-visible');
      subscribeField?.classList.remove('is-error');
    };

    const setSubscribeMessage = (message, isError = false) => {
      if (!subscribeStatus) return;
      if (subscribeStatusText) subscribeStatusText.textContent = message;
      subscribeStatus.classList.toggle('is-error', isError);
      subscribeField?.classList.toggle('is-error', isError);
      requestAnimationFrame(() => {
        subscribeStatus.classList.add('is-visible');
      });
    };

    const bindExploreSubscribe = () => {
      if (!subscribeForm || !window.ElementNewsletter) return;
      subscribeForm.dataset.elementNewsletterManual = 'true';
      window.ElementNewsletter.bindForm(subscribeForm, {
        onStart: () => hideSubscribeMessage(),
        onSuccess: (message) => {
          subscribe?.classList.add('is-success');
          setSubscribeMessage(message);
        },
        onError: (message) => {
          setSubscribeMessage(message, true);
          subscribeInput?.focus({ preventScroll: true });
        },
      });
    };

    const open = (event) => {
      if (!dialog || dialog.classList.contains('is-open')) return;
      lastTrigger = event?.currentTarget || trigger;
      trigger?.classList.remove('is-visible');
      triggers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      footer?.classList.remove('is-explore-active');
      if (panel) panel.style.transform = '';
      if (body) body.scrollTop = 0;
      dialog.classList.remove('is-closing', 'is-dragging');
      dialog.hidden = false;
      document.body.classList.add('has-modal-open');

      if (reduced) {
        dialog.classList.add('is-open');
        dialog.querySelector('button[data-explore-close]')?.focus({ preventScroll: true });
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          dialog.classList.add('is-open');
          dialog.querySelector('button[data-explore-close]')?.focus({ preventScroll: true });
        });
      });
    };

    const finishClose = () => {
      clearTimeout(closing);
      dialog?.classList.remove('is-closing', 'is-open', 'is-dragging');
      if (panel) panel.style.transform = '';
      if (dialog) dialog.hidden = true;
      document.body.classList.remove('has-modal-open');
      triggers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      if (search) search.value = '';
      updateSearch();
      updateTrigger();
      lastTrigger?.focus({ preventScroll: true });
      lastTrigger = null;

      const next = afterClose;
      afterClose = null;
      next?.();
    };

    const close = (onClosed) => {
      if (typeof onClosed === 'function') afterClose = onClosed;
      if (!dialog || dialog.hidden || dialog.classList.contains('is-closing')) {
        if (dialog?.hidden && afterClose) {
          const next = afterClose;
          afterClose = null;
          next();
        }
        return;
      }
      if (reduced) {
        finishClose();
        return;
      }
      dialog.classList.remove('is-open', 'is-dragging');
      dialog.classList.add('is-closing');
      if (panel) panel.style.transform = '';
      const onEnd = (event) => {
        if (event.target !== panel) return;
        if (event.propertyName !== 'transform') return;
        finishClose();
      };
      panel?.addEventListener('transitionend', onEnd, { once: true });
      closing = setTimeout(finishClose, 850);
    };

    const onHandlePointerDown = (event) => {
      if (!dialog || dialog.hidden || event.button || (event.pointerType === 'touch' && mobileSheet.matches)) return;
      if (event.target.closest('[data-explore-close]')) return;
      event.preventDefault();
      drag = {
        startY: event.clientY,
        pointerId: event.pointerId,
        dragging: false
      };
      handle?.setPointerCapture?.(event.pointerId);
    };

    const onHandlePointerMove = (event) => {
      if (!drag || event.pointerId !== drag.pointerId || !panel) return;
      const delta = event.clientY - drag.startY;
      if (!drag.dragging && Math.abs(delta) < 6) return;
      drag.dragging = true;
      dialog.classList.add('is-dragging');
      dialog.classList.remove('is-closing');
      panel.style.transform = delta > 0
        ? `translateY(${delta}px)`
        : mobileSheet.matches ? 'translateY(0)' : '';
    };

    const onHandlePointerUp = (event) => {
      if (!drag || event.pointerId !== drag.pointerId || !panel) return;
      const delta = event.clientY - drag.startY;
      const shouldClose = drag.dragging && delta > Math.min(140, window.innerHeight * 0.18);
      drag = null;
      dialog.classList.remove('is-dragging');
      if (shouldClose) {
        close();
        return;
      }
      panel.style.transform = '';
      dialog.classList.add('is-open');
    };

        // Let Explore content scroll while it has room; otherwise move the sheet.
        const canScroll = (target, delta) => {
          for (let node = target; node && node !== dialog; node = node.parentElement) {
            if (!/(auto|scroll)/.test(getComputedStyle(node).overflowY)) continue;
            if (node.scrollHeight <= node.clientHeight + 1) continue;
            if (delta > 0 && node.scrollTop > 0) return true;
            if (delta < 0 && node.scrollTop + node.clientHeight < node.scrollHeight - 1) return true;
          }
          return false;
        };
        let touchDrag = null;
        let suppressClickUntil = 0;
        dialog?.addEventListener( 'touchstart', (event) => {
          if (!dialog.classList.contains('is-open') || event.touches.length !== 1 || !mobileSheet.matches) return;
          const touch = event.touches[0];
          touchDrag = { x: touch.clientX, y: touch.clientY, lastY: touch.clientY, target: event.target, moving: false, delta: 0 };
        }, { passive: true });
        dialog?.addEventListener( 'touchmove', (event) => {
          if (!touchDrag || event.touches.length !== 1 || !dialog.classList.contains('is-open')) return;
          const touch = event.touches[0];
          const delta = touch.clientY - touchDrag.y;
          const step = touch.clientY - touchDrag.lastY;
          touchDrag.lastY = touch.clientY;
          if (!touchDrag.moving) {
            if (Math.abs(delta) < 6 || Math.abs(touch.clientX - touchDrag.x) > Math.abs(delta)) return;
            if (canScroll(touchDrag.target, step)) { touchDrag.y = touch.clientY; return; }
          }
          event.preventDefault();
          // Modal dialogs and the backdrop stay still, but cannot scroll the page.
          if (!touchDrag.target.closest('[data-explore-panel]') || touchDrag.target.closest('dialog:not([data-explore-dialog])')) return;
          touchDrag.moving = true;
          touchDrag.delta = delta;
          dialog.classList.add('is-dragging');
          panel.style.transform = `translate3d(0, ${Math.max(0, delta)}px, 0)`;
        }, { passive: false });
        const finishTouch = (event) => {
          if (!touchDrag) return;
          const shouldClose = event.type !== 'touchcancel' && touchDrag.moving && touchDrag.delta > Math.min(140, window.innerHeight * 0.18);
          if (touchDrag.moving) suppressClickUntil = Date.now() + 350;
          touchDrag = null;
          dialog.classList.remove('is-dragging');
          if (panel) panel.style.transform = '';
          if (shouldClose) close();
        };
        dialog?.addEventListener( 'touchend', finishTouch);
        dialog?.addEventListener( 'touchcancel', finishTouch);
        dialog?.addEventListener( 'click', (event) => {
          if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, { capture: true });
        dialog?.addEventListener( 'wheel', (event) => {
          if (dialog.classList.contains('is-open') && !canScroll(event.target, -event.deltaY)) event.preventDefault();
        }, { passive: false });


    triggers.forEach((button) => button.addEventListener('click', open));
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog?.querySelectorAll('[data-explore-close]').forEach((button) => {
      button.addEventListener('click', close);
    });
    handle?.addEventListener('pointerdown', onHandlePointerDown);
    handle?.addEventListener('pointermove', onHandlePointerMove);
    handle?.addEventListener('pointerup', onHandlePointerUp);
    handle?.addEventListener('pointercancel', onHandlePointerUp);
    search?.addEventListener('input', updateSearch);
    search?.addEventListener('keydown', (event) => {
      const hasOptions = Boolean(suggest && !suggest.hidden && suggest.querySelector('[data-suggest-index]'));

      if (event.key === 'ArrowDown' && hasOptions) {
        event.preventDefault();
        setActiveSuggest(activeSuggest + 1);
        return;
      }

      if (event.key === 'ArrowUp' && hasOptions) {
        event.preventDefault();
        setActiveSuggest(activeSuggest - 1);
        return;
      }

      if (event.key === 'Enter' && hasOptions && activeSuggest >= 0) {
        event.preventDefault();
        openSuggestItem(currentMatches[activeSuggest]?.item);
        return;
      }

      if (event.key === 'Escape' && (search.value || (suggest && !suggest.hidden))) {
        event.preventDefault();
        event.stopPropagation();
        search.value = '';
        hideSuggest();
      }
    });
    dialog?.addEventListener('pointerdown', (event) => {
      if (searchBox && !searchBox.contains(event.target)) hideSuggest();
    });
    subscribeTrigger?.addEventListener('click', expandSubscribe);
    subscribeForm?.setAttribute('novalidate', '');
    if (window.ElementNewsletter) {
      bindExploreSubscribe();
    } else {
      document.addEventListener('DOMContentLoaded', bindExploreSubscribe);
    }
    subscribeLists.forEach((input) => {
      const label = input.closest('label');
      const syncList = () => {
        label?.classList.toggle('is-selected', input.checked);
        syncSubscribeTags();
        if (selectedSubscribeTags().length && subscribeStatus?.classList.contains('is-error')) {
          hideSubscribeMessage();
        }
      };
      input.addEventListener('change', syncList);
      syncList();
    });
    links.forEach((link) => link.addEventListener('click', close));
    if (product && !product.hasAttribute('data-explore-product-add')) {
      product.addEventListener('click', close);
    }
    window.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        updateTrigger();
        frame = null;
      });
    }, { passive: true });
    window.addEventListener('resize', updateTrigger, { passive: true });
    syncSubscribeTags();
    updateSearch();
    updateTrigger();

    const stickyForm = stickyBar?.querySelector('form[action*="/cart/add"]');
    const estimatedDispatchInput = stickyForm?.querySelector('[data-estimated-dispatch-property]');
    const dropdown = stickyBar?.querySelector('[data-colour-dropdown]');
    const dropdownTrigger = stickyBar?.querySelector('[data-colour-dropdown-trigger]');
    const colourOptions = stickyBar ? [...stickyBar.querySelectorAll('[data-colour-option]')] : [];
    const selectedColour = stickyBar?.querySelector('[data-selected-colour]');
    const selectedDot = stickyBar?.querySelector('[data-selected-colour-dot]');
    const variantInput = stickyBar?.querySelector('[data-sticky-variant-id]');
    const price = stickyBar?.querySelector('[data-sticky-prices] .element-sticky-product-bar__price');
    const compare = stickyBar?.querySelector('[data-sticky-prices] .element-sticky-product-bar__compare');
    const availability = stickyBar?.querySelector('[data-sticky-availability]');
    const buyNowButton = stickyBar?.querySelector('[data-sticky-add-to-cart]');
    const stickyCartButton = stickyBar?.querySelector('[data-sticky-cart-button]');
    const stickyCartCount = stickyBar?.querySelector('[data-sticky-cart-count]');
    const exploreAdd = dialog?.querySelector('[data-explore-product-add]');
    const cartRoot = window.Shopify?.routes?.root || '/';

    const colourHandle = (colour) => {
      const key = String(colour || '').toLowerCase().trim().replace(/\s+/g, '-');
      if (key === 'birch') return 'bone';
      if (key === 'charcoal') return 'carbon';
      return key;
    };

    const coloursMatch = (left, right) => colourHandle(left) === colourHandle(right);

    const applyColour = (option, { syncHome = true, broadcast = true } = {}) => {
      if (!option) return;

      const colour = option.dataset.colour;
      const finish = colourHandle(colour);
      const variantId = option.dataset.variantId;
      const variantPrice = option.dataset.variantPrice;
      const variantCompare = option.dataset.variantCompare;
      const available = option.dataset.variantAvailable === 'true';

      if (variantInput) variantInput.value = variantId;
      if (estimatedDispatchInput) estimatedDispatchInput.value = option.dataset.estimatedDispatch || '';
      if (selectedColour) selectedColour.textContent = colour;
      if (selectedDot) {
        selectedDot.className = `element-sticky-product-bar__colour-dot element-sticky-product-bar__colour-dot--${finish}`;
      }
      if (price) price.textContent = variantPrice;
      if (availability) {
        const backorderLabel = (option.dataset.backorderLabel || '').trim();
        availability.textContent = backorderLabel;
        availability.hidden = backorderLabel === '';
      }
      if (compare) {
        const showCompare = variantCompare && variantCompare !== variantPrice && variantCompare !== '$0.00';
        compare.textContent = variantCompare || '';
        compare.hidden = !showCompare;
        compare.style.display = showCompare ? '' : 'none';
      }
      if (buyNowButton) {
        buyNowButton.disabled = !available;
        const stickyLabel = buyNowButton.querySelector('[data-sticky-add-label]');
        if (stickyLabel) stickyLabel.textContent = available ? 'Buy →' : 'Sold Out';
        else buyNowButton.textContent = available ? 'Buy →' : 'Sold Out';
      }

      colourOptions.forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-selected', String(selected));
      });

      dropdown?.classList.remove('is-open');
      dropdownTrigger?.setAttribute('aria-expanded', 'false');

      if (syncHome) {
        const homeFinish = document.querySelector(`[data-v2-variant][data-variant-id="${variantId}"]`);
        if (homeFinish && !homeFinish.classList.contains('is-selected')) homeFinish.click();
      }

      if (broadcast) {
        window.ElementColourState = { colour, finish };
        document.dispatchEvent(new CustomEvent('element:sticky-colour-change', {
          detail: { colour, finish, source: 'sticky' }
        }));
      }
    };

    const applyColourFromName = (colour, finish) => {
      const option = colourOptions.find((item) => (
        coloursMatch(item.dataset.colour, finish) ||
        coloursMatch(item.dataset.colour, colour)
      ));

      if (!option || option.classList.contains('is-selected')) return;

      applyColour(option, { syncHome: false, broadcast: false });
    };

    const visibleCartCount = (cart) => {
      if (!cart) return 0;

      if (Array.isArray(cart.items)) {
        return cart.items.reduce((sum, item) => {
          const properties = item.properties || {};
          if (properties['_Warranty upgrade'] === 'true') return sum;
          return sum + (Number(item.quantity) || 0);
        }, 0);
      }

      return Math.max(0, Number(cart.item_count) || 0);
    };

    const updateCartCount = (itemCount) => {
      const count = Math.max(0, Number(itemCount) || 0);

      if (stickyCartButton) {
        stickyCartButton.hidden = count === 0;
        stickyCartButton.setAttribute('aria-label', `Open cart, ${count} ${count === 1 ? 'item' : 'items'}`);
      }
      if (stickyCartCount) stickyCartCount.textContent = String(count);
    };

    const refreshCartCount = async () => {
      try {
        const response = await fetch(`${cartRoot}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!response.ok) return;
        const cart = await response.json();
        updateCartCount(visibleCartCount(cart));
      } catch (error) {
        console.error('Element cart count error:', error);
      }
    };

    const openCartDrawer = async (opener, { afterAdd = false } = {}) => {
      const cartDrawer = document.getElementById('CartDrawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        if (afterAdd) {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: true, animate: Boolean(cartDrawer.open) }
          }));
          return true;
        }

        cartDrawer.show(opener);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        return true;
      }

      const drawerTrigger = document.querySelector('[aria-controls="CartDrawer"]:not(.drawer__close):not(.overlay)');
      if (drawerTrigger) {
        drawerTrigger.click();
        return true;
      }

      window.location.href = `${cartRoot}cart`;
      return false;
    };

    dropdownTrigger?.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = dropdown.classList.toggle('is-open');
      dropdownTrigger.setAttribute('aria-expanded', String(isOpen));
    });

    colourOptions.forEach((option) => {
      option.addEventListener('click', () => applyColour(option));
    });

    document.addEventListener('click', (event) => {
      if (dropdown && !dropdown.contains(event.target)) {
        dropdown.classList.remove('is-open');
        dropdownTrigger?.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('element:home-v2-variant-change', (event) => {
      const variantId = String(event.detail?.variantId || '');
      const option = colourOptions.find((item) => item.dataset.variantId === variantId);
      applyColour(option, { syncHome: false, broadcast: true });
    });

    document.addEventListener('element:carousel-colour-change', (event) => {
      applyColourFromName(event.detail?.colour, event.detail?.finish);
    });

    document.addEventListener('element:sticky-colour-change', (event) => {
      if (event.detail?.source === 'sticky') return;
      applyColourFromName(event.detail?.colour, event.detail?.finish);
    });

    if (window.ElementColourState) {
      applyColourFromName(window.ElementColourState.colour, window.ElementColourState.finish);
    }

    let addingToCart = false;

    const addSelectedToCart = async (opener, { openDrawer = true } = {}) => {
      const variantId = variantInput?.value;
      if (addingToCart || !variantId) return false;

      addingToCart = true;

      try {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        if (estimatedDispatchInput?.value) {
          formData.append('properties[Estimated dispatch]', estimatedDispatchInput.value);
        }

        const response = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || 'Unable to add this product to the cart.');
        }

        await refreshCartCount();
        document.dispatchEvent(new CustomEvent('element:cart-added', {
          bubbles: true,
          detail: { variantId }
        }));

        if (openDrawer) {
          await openCartDrawer(opener || buyNowButton, { afterAdd: true });
        }

        return true;
      } catch (error) {
        console.error('Element Add to Cart error:', error);
        return false;
      } finally {
        addingToCart = false;
      }
    };

    stickyForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!buyNowButton || buyNowButton.disabled || !variantInput?.value) return;

      buyNowButton.disabled = true;
      buyNowButton.classList.add('is-loading');
      buyNowButton.setAttribute('aria-busy', 'true');

      const added = await addSelectedToCart(buyNowButton);
      buyNowButton.disabled = false;
      buyNowButton.classList.remove('is-loading');
      buyNowButton.removeAttribute('aria-busy');
      if (!added) return;
    });

    document.addEventListener('element:add-selected-to-cart', async (event) => {
      const opener = event.detail?.opener || buyNowButton;
      if (!variantInput?.value || buyNowButton?.disabled) {
        event.detail?.resolve?.(false);
        return;
      }
      const added = await addSelectedToCart(opener);
      event.detail?.resolve?.(added);
    });

    stickyCartButton?.addEventListener('click', (event) => {
      event.preventDefault();
      openCartDrawer(stickyCartButton);
    });

    exploreAdd?.addEventListener('click', async (event) => {
      event.preventDefault();
      if (!variantInput?.value || addingToCart) return;

      exploreAdd.classList.add('is-loading');
      exploreAdd.setAttribute('aria-busy', 'true');

      const added = await addSelectedToCart(exploreAdd, { openDrawer: false });

      if (!added) {
        exploreAdd.classList.remove('is-loading');
        exploreAdd.removeAttribute('aria-busy');
        return;
      }

      close(() => {
        exploreAdd.classList.remove('is-loading');
        exploreAdd.removeAttribute('aria-busy');
        openCartDrawer(exploreAdd, { afterAdd: true });
      });
    });

    document.addEventListener('keydown', (event) => {
      const target = event.target;
      const isTyping = target && (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT' ||
        target.isContentEditable
      );

      if (event.key === 'Escape' && dialog && !dialog.hidden) {
        if (search?.value || (suggest && !suggest.hidden)) {
          event.preventDefault();
          search.value = '';
          hideSuggest();
          return;
        }

        event.preventDefault();
        close();
        return;
      }

      if (
        event.key === '/' &&
        !isTyping &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.altKey
      ) {
        event.preventDefault();
        open();
      }
    });

    window.addEventListener('pageshow', refreshCartCount);
    document.addEventListener('cart:refresh', refreshCartCount);
    document.addEventListener('element:cart-added', refreshCartCount);

    const subscribeCartCount = () => {
      const pubsub = window.theme?.pubsub;
      if (!pubsub?.subscribe || !pubsub.PUB_SUB_EVENTS?.cartUpdate) return false;

      pubsub.subscribe(pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.cart) {
          updateCartCount(visibleCartCount(event.cart));
          return;
        }
        refreshCartCount();
      });
      return true;
    };

    if (!subscribeCartCount()) {
      document.addEventListener('page:loaded', subscribeCartCount, { once: true });
    }

    updateCartCount(stickyBar?.dataset.cartCount);
    refreshCartCount();
  })();
